export default function Hero() {
  return (
    <div className="bg-gradient-to-r from-indigo-500 to-purple-500 text-white py-14 px-4 text-center">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">PaPiRa Blogへようこそ！</h1>
      <p className="text-lg md:text-xl mb-6">システムエンジニアを目指すを妖精・PaPiRaくんのWeb日記</p>
      {/*
      <a
        href="#posts"
        className="inline-block bg-white text-indigo-600 font-semibold px-6 py-3 rounded hover:bg-gray-100 transition"
      >
        記事一覧を見る
      </a>
      */}
    </div>
  );
}